/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIModel
 */
export interface AIModel {
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    provider?: string;
    /**
     * 
     * @type {string}
     * @memberof AIModel
     */
    model?: string;
    /**
     * 
     * @type {number}
     * @memberof AIModel
     */
    budget_tokens?: number;
}

/**
 * Check if a given object implements the AIModel interface.
 */
export function instanceOfAIModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AIModelFromJSON(json: any): AIModel {
    return AIModelFromJSONTyped(json, false);
}

export function AIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'model': !exists(json, 'model') ? undefined : json['model'],
        'budget_tokens': !exists(json, 'budget_tokens') ? undefined : json['budget_tokens'],
    };
}

export function AIModelToJSON(value?: AIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
        'model': value.model,
        'budget_tokens': value.budget_tokens,
    };
}

